module.exports = __webpack_public_path__ + "img/3.9456c0a8.png";